import styled from 'styled-components'
import { ResponsiveImage } from '../../ResponsiveImage/ResponsiveImage'

export const BlocksGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto 1fr;
  // Overflow hidden is required to prevent the images from overflowing the grid in safari
  overflow: hidden;
  grid-template-areas:
    'LookbookBlockItem0 LookbookBlockItem1'
    'LookbookBlockItem2 LookbookBlockItem2';
  gap: 0.8rem;

  & > div {
    &:nth-child(1) {
      aspect-ratio: 1;
      grid-area: LookbookBlockItem0;
    }

    &:nth-child(2) {
      aspect-ratio: 1;
      grid-area: LookbookBlockItem1;
    }

    &:nth-child(3) {
      aspect-ratio: 1;
      grid-area: LookbookBlockItem2;
    }
  }

  @media screen and (min-width: 768px) {
    aspect-ratio: auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-flow: row;
    grid-template-areas:
      'LookbookBlockItem0 LookbookBlockItem2 LookbookBlockItem2'
      'LookbookBlockItem1 LookbookBlockItem2 LookbookBlockItem2';
  }
`

export const StyledResponsiveImage = styled(ResponsiveImage)`
  width: 100%;
  object-fit: cover;
  aspect-ratio: 1;
`
